import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-psa-licence-req-form',
  templateUrl: './psa-licence-req-form.component.html',
  styleUrls: ['./psa-licence-req-form.component.css']
})
export class PsaLicenceReqFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/psadetails/psa-list/psa-licence-request/psa-licence-req-form/psa-licence-req-form.component.ts